// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.practice-tab {
  padding: 0;
}

.practice-tab-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 0 12px;
  flex-wrap: wrap;
}

.practice-tab-count {
  font-weight: 600;
  font-size: 14px;
  color: var(--text, #f1f5f9);
}

.practice-tab-track {
  font-size: 13px;
  font-weight: 600;
  color: var(--text, #e2e8f0);
  background-color: rgba(96, 165, 250, 0.1);
  border: 1px solid rgba(96, 165, 250, 0.2);
  border-radius: 4px;
  padding: 2px 8px;
}

.practice-tab-hint {
  font-size: 12px;
  color: var(--muted, #94a3b8);
}

.practice-tab-empty {
  padding: 32px 0;
  text-align: center;
  color: var(--muted, #94a3b8);
  font-size: 14px;
  line-height: 1.6;
}

/* ─── Best laps table ─────────────────────────────────────────────────────── */

.practice-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.practice-table thead {
  background-color: #1e293b;
  position: sticky;
  top: 0;
  z-index: 2;
}

.practice-table th {
  padding: 12px 10px;
  text-align: left;
  font-weight: 600;
  color: #cbd5e1;
  border-bottom: 1px solid #334155;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.practice-table th .sort-btn,
.lap-details-table th .sort-btn {
  background: none;
  border: none;
  padding: 0;
  color: inherit;
  cursor: pointer;
  font: inherit;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.practice-table td {
  padding: 10px 10px;
  color: #e2e8f0;
  border-bottom: 1px solid #334155;
}

.practice-table tbody tr {
  transition: background-color 0.15s;
}

.practice-table tbody tr:hover {
  background-color: #334155;
}

.practice-row.clickable {
  cursor: pointer;
}

.practice-row.best-lap {
  background-color: rgba(168, 85, 247, 0.1);
}

.practice-row.best-lap:hover {
  background-color: rgba(168, 85, 247, 0.18);
}

/* Sort bar — visible only on mobile */
.practice-sort-bar {
  display: none;
  align-items: center;
  gap: 8px;
  padding: 8px 0 4px;
}

.practice-sort-label {
  font-size: 12px;
  color: var(--muted, #94a3b8);
  white-space: nowrap;
}

.practice-sort-select {
  flex: 1 1;
  width: auto;
  border: 1px solid var(--border, #334155);
  border-radius: 6px;
  padding: 5px 8px;
  background: var(--surface, #0f172a);
  color: var(--text, #e2e8f0);
  font-size: 12px;
}

/* Driver cell: name + inline car-number badge side by side */
.practice-driver-cell {
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  min-width: 0;
}

/* Inline car number badge — smaller than the standalone col-num badge */
.practice-inline-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  height: 16px;
  background-color: #111827;
  border-radius: 4px;
  font-weight: 700;
  color: #e2e8f0;
  font-size: 10px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
  line-height: 1;
}

body.light-theme .practice-inline-number {
  background-color: var(--surface-strong);
  color: var(--text);
  border-color: var(--border);
}

.practice-driver-name {
  font-weight: 500;
  color: #f1f5f9;
}

.practice-driver-name.driver-link {
  color: var(--secondary-color, #60a5fa);
}

.practice-driver-name.driver-link:hover {
  text-decoration: underline;
}

.car-model-cell {
  color: #cbd5e1;
  font-size: 13px;
}

.col-pos {
  width: 40px;
  text-align: center;
  font-weight: 600;
  color: #94a3b8;
}

.col-time {
  text-align: right;
  font-family: 'Courier New', monospace;
  white-space: nowrap;
}

.col-num {
  text-align: center;
  white-space: nowrap;
}

.mono {
  font-family: 'Courier New', monospace;
}

/* ─── Driver laps modal ───────────────────────────────────────────────────── */

.practice-driver-modal {
  width: min(1040px, 100%);
  max-height: 85vh;
}

.practice-session-group {
  border-bottom: 1px solid #334155;
}

.practice-session-group:last-child {
  border-bottom: none;
}

.practice-session-header {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  background: none;
  border: none;
  border-bottom: 1px solid #1e293b;
  color: #cbd5e1;
  cursor: pointer;
  font-size: 13px;
  text-align: left;
  transition: background-color 0.15s;
}

.practice-session-header:hover {
  background-color: rgba(51, 65, 85, 0.4);
}

.practice-session-label {
  flex: 1 1;
  font-weight: 500;
  color: #f1f5f9;
}

.practice-session-meta {
  font-size: 12px;
  color: #94a3b8;
  white-space: nowrap;
}

/* ─── Light theme ─────────────────────────────────────────────────────────── */

body.light-theme .practice-table thead {
  background-color: var(--surface-strong);
}

body.light-theme .practice-table th {
  color: var(--muted-strong);
  border-bottom-color: var(--border);
}

body.light-theme .practice-table td {
  color: var(--text);
  border-bottom-color: var(--border);
}

body.light-theme .practice-table tbody tr:hover {
  background-color: rgba(15, 23, 42, 0.05);
}

body.light-theme .practice-driver-name {
  color: var(--text);
}

body.light-theme .car-model-cell {
  color: var(--muted);
}

body.light-theme .practice-session-header {
  border-color: var(--border);
  color: var(--muted-strong);
}

body.light-theme .practice-session-label {
  color: var(--text);
}

body.light-theme .practice-session-meta {
  color: var(--muted);
}

body.light-theme .practice-tab-count {
  color: var(--text);
}

/* ─── Mobile ──────────────────────────────────────────────────────────────── */

@media (max-width: 768px) {
  .practice-sort-bar {
    display: flex;
  }

  .table-wrapper .practice-table thead {
    display: none;
  }

  .table-wrapper .practice-table,
  .table-wrapper .practice-table tbody {
    display: block;
    width: 100%;
  }

  /*
   * Compact two-line strip per driver:
   *
   *   [pos]  [driver name]   [best lap]
   *          [car model]     [lap count]
   *
   * Columns: 28px · 1fr · auto
   * td 1 (pos)       → col 1, rows 1–2, centered
   * td 2 (driver)    → col 2, row 1
   * td 3 (car #)     → hidden
   * td 4 (car model) → col 2, row 2
   * td 5 (best lap)  → col 3, row 1
   * td 6 (lap count) → col 3, row 2
   * td 7 (date)      → hidden
   */
  .table-wrapper .practice-table tr {
    display: grid;
    grid-template-columns: 28px 1fr auto;
    grid-template-rows: auto auto;
    column-gap: 8px;
    row-gap: 0;
    padding: 7px 10px;
    border: none;
    border-bottom: 1px solid #1e293b;
    background: transparent;
    margin: 0;
    border-radius: 0;
    align-items: center;
  }

  .table-wrapper .practice-table tbody tr:first-child {
    border-top: 1px solid #1e293b;
  }

  .table-wrapper .practice-table td {
    padding: 0;
    border: none;
    font-size: 13px;
    line-height: 1.4;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Position number — spans both rows, centred */
  .table-wrapper .practice-table td.col-pos {
    grid-column: 1;
    grid-row: 1 / 3;
    text-align: center;
    font-weight: 700;
    font-size: 13px;
    color: #94a3b8;
    align-self: center;
  }

  /* Driver name — row 1, col 2 */
  .table-wrapper .practice-table td:nth-child(2) {
    grid-column: 2;
    grid-row: 1;
    font-weight: 600;
    font-size: 13px;
    min-width: 0;
    overflow: hidden;
  }

  /* Driver cell: allow name to truncate, keep badge visible */
  .table-wrapper .practice-table td:nth-child(2) .practice-driver-cell {
    display: flex;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
  }

  .table-wrapper .practice-table td:nth-child(2) .practice-driver-name {
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1 1;
    min-width: 0;
  }

  .table-wrapper .practice-table td:nth-child(2) .practice-inline-number {
    flex-shrink: 0;
  }

  /* Car number — hidden */
  .table-wrapper .practice-table td:nth-child(3) {
    display: none;
  }

  /* Car model — row 2, col 2 */
  .table-wrapper .practice-table td:nth-child(4) {
    grid-column: 2;
    grid-row: 2;
    min-width: 0;
  }

  .table-wrapper .practice-table td:nth-child(4) .car-model-cell {
    font-size: 11px;
    color: #64748b;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }

  /* Best lap — row 1, col 3, right-aligned */
  .table-wrapper .practice-table td:nth-child(5) {
    grid-column: 3;
    grid-row: 1;
    text-align: right;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    font-weight: 600;
  }

  /* Total laps — row 2, col 3, right-aligned, muted */
  .table-wrapper .practice-table td:nth-child(6) {
    grid-column: 3;
    grid-row: 2;
    text-align: right;
    font-size: 11px;
    color: #64748b;
  }

  /* Date — hidden */
  .table-wrapper .practice-table td:nth-child(7) {
    display: none;
  }

  .table-wrapper .practice-table tbody tr.best-lap {
    background-color: rgba(168, 85, 247, 0.07);
  }

  .practice-driver-modal {
    max-height: 90vh;
  }
}

body.light-theme .table-wrapper .practice-table tr {
  border-bottom-color: var(--border);
}

body.light-theme .table-wrapper .practice-table tbody tr:first-child {
  border-top-color: var(--border);
}

body.light-theme .table-wrapper .practice-table td:nth-child(4) .car-model-cell,
body.light-theme .table-wrapper .practice-table td:nth-child(6) {
  color: var(--muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/PracticeTab.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yCAAyC;EACzC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA,gFAAgF;;AAEhF;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA,wEAAwE;AACxE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,gFAAgF;;AAEhF;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,gFAAgF;;AAEhF;EACE,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gFAAgF;;AAEhF;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;IACd,WAAW;EACb;;EAEA;;;;;;;;;;;;;;IAcE;EACF;IACE,aAAa;IACb,oCAAoC;IACpC,6BAA6B;IAC7B,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,+CAA+C;EAC/C;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA,+BAA+B;EAC/B;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA,4DAA4D;EAC5D;IACE,aAAa;IACb,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,SAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA,wBAAwB;EACxB;IACE,aAAa;EACf;;EAEA,6BAA6B;EAC7B;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;EAChB;;EAEA,2CAA2C;EAC3C;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;EAClB;;EAEA,oDAAoD;EACpD;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,aAAa;EACf;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,mBAAmB;AACrB","sourcesContent":[".practice-tab {\r\n  padding: 0;\r\n}\r\n\r\n.practice-tab-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 14px 0 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.practice-tab-count {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: var(--text, #f1f5f9);\r\n}\r\n\r\n.practice-tab-track {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--text, #e2e8f0);\r\n  background-color: rgba(96, 165, 250, 0.1);\r\n  border: 1px solid rgba(96, 165, 250, 0.2);\r\n  border-radius: 4px;\r\n  padding: 2px 8px;\r\n}\r\n\r\n.practice-tab-hint {\r\n  font-size: 12px;\r\n  color: var(--muted, #94a3b8);\r\n}\r\n\r\n.practice-tab-empty {\r\n  padding: 32px 0;\r\n  text-align: center;\r\n  color: var(--muted, #94a3b8);\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* ─── Best laps table ─────────────────────────────────────────────────────── */\r\n\r\n.practice-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\n.practice-table thead {\r\n  background-color: #1e293b;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 2;\r\n}\r\n\r\n.practice-table th {\r\n  padding: 12px 10px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #cbd5e1;\r\n  border-bottom: 1px solid #334155;\r\n  user-select: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.practice-table th .sort-btn,\r\n.lap-details-table th .sort-btn {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  font: inherit;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.practice-table td {\r\n  padding: 10px 10px;\r\n  color: #e2e8f0;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.practice-table tbody tr {\r\n  transition: background-color 0.15s;\r\n}\r\n\r\n.practice-table tbody tr:hover {\r\n  background-color: #334155;\r\n}\r\n\r\n.practice-row.clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.practice-row.best-lap {\r\n  background-color: rgba(168, 85, 247, 0.1);\r\n}\r\n\r\n.practice-row.best-lap:hover {\r\n  background-color: rgba(168, 85, 247, 0.18);\r\n}\r\n\r\n/* Sort bar — visible only on mobile */\r\n.practice-sort-bar {\r\n  display: none;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 0 4px;\r\n}\r\n\r\n.practice-sort-label {\r\n  font-size: 12px;\r\n  color: var(--muted, #94a3b8);\r\n  white-space: nowrap;\r\n}\r\n\r\n.practice-sort-select {\r\n  flex: 1;\r\n  width: auto;\r\n  border: 1px solid var(--border, #334155);\r\n  border-radius: 6px;\r\n  padding: 5px 8px;\r\n  background: var(--surface, #0f172a);\r\n  color: var(--text, #e2e8f0);\r\n  font-size: 12px;\r\n}\r\n\r\n/* Driver cell: name + inline car-number badge side by side */\r\n.practice-driver-cell {\r\n  display: inline-flex;\r\n  align-items: baseline;\r\n  gap: 5px;\r\n  min-width: 0;\r\n}\r\n\r\n/* Inline car number badge — smaller than the standalone col-num badge */\r\n.practice-inline-number {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 4px;\r\n  height: 16px;\r\n  background-color: #111827;\r\n  border-radius: 4px;\r\n  font-weight: 700;\r\n  color: #e2e8f0;\r\n  font-size: 10px;\r\n  border: 1px solid rgba(255, 255, 255, 0.06);\r\n  flex-shrink: 0;\r\n  line-height: 1;\r\n}\r\n\r\nbody.light-theme .practice-inline-number {\r\n  background-color: var(--surface-strong);\r\n  color: var(--text);\r\n  border-color: var(--border);\r\n}\r\n\r\n.practice-driver-name {\r\n  font-weight: 500;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.practice-driver-name.driver-link {\r\n  color: var(--secondary-color, #60a5fa);\r\n}\r\n\r\n.practice-driver-name.driver-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.car-model-cell {\r\n  color: #cbd5e1;\r\n  font-size: 13px;\r\n}\r\n\r\n.col-pos {\r\n  width: 40px;\r\n  text-align: center;\r\n  font-weight: 600;\r\n  color: #94a3b8;\r\n}\r\n\r\n.col-time {\r\n  text-align: right;\r\n  font-family: 'Courier New', monospace;\r\n  white-space: nowrap;\r\n}\r\n\r\n.col-num {\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.mono {\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n/* ─── Driver laps modal ───────────────────────────────────────────────────── */\r\n\r\n.practice-driver-modal {\r\n  width: min(1040px, 100%);\r\n  max-height: 85vh;\r\n}\r\n\r\n.practice-session-group {\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.practice-session-group:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.practice-session-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 10px 14px;\r\n  background: none;\r\n  border: none;\r\n  border-bottom: 1px solid #1e293b;\r\n  color: #cbd5e1;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  text-align: left;\r\n  transition: background-color 0.15s;\r\n}\r\n\r\n.practice-session-header:hover {\r\n  background-color: rgba(51, 65, 85, 0.4);\r\n}\r\n\r\n.practice-session-label {\r\n  flex: 1;\r\n  font-weight: 500;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.practice-session-meta {\r\n  font-size: 12px;\r\n  color: #94a3b8;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ─── Light theme ─────────────────────────────────────────────────────────── */\r\n\r\nbody.light-theme .practice-table thead {\r\n  background-color: var(--surface-strong);\r\n}\r\n\r\nbody.light-theme .practice-table th {\r\n  color: var(--muted-strong);\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .practice-table td {\r\n  color: var(--text);\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .practice-table tbody tr:hover {\r\n  background-color: rgba(15, 23, 42, 0.05);\r\n}\r\n\r\nbody.light-theme .practice-driver-name {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .car-model-cell {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .practice-session-header {\r\n  border-color: var(--border);\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .practice-session-label {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .practice-session-meta {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .practice-tab-count {\r\n  color: var(--text);\r\n}\r\n\r\n/* ─── Mobile ──────────────────────────────────────────────────────────────── */\r\n\r\n@media (max-width: 768px) {\r\n  .practice-sort-bar {\r\n    display: flex;\r\n  }\r\n\r\n  .table-wrapper .practice-table thead {\r\n    display: none;\r\n  }\r\n\r\n  .table-wrapper .practice-table,\r\n  .table-wrapper .practice-table tbody {\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  /*\r\n   * Compact two-line strip per driver:\r\n   *\r\n   *   [pos]  [driver name]   [best lap]\r\n   *          [car model]     [lap count]\r\n   *\r\n   * Columns: 28px · 1fr · auto\r\n   * td 1 (pos)       → col 1, rows 1–2, centered\r\n   * td 2 (driver)    → col 2, row 1\r\n   * td 3 (car #)     → hidden\r\n   * td 4 (car model) → col 2, row 2\r\n   * td 5 (best lap)  → col 3, row 1\r\n   * td 6 (lap count) → col 3, row 2\r\n   * td 7 (date)      → hidden\r\n   */\r\n  .table-wrapper .practice-table tr {\r\n    display: grid;\r\n    grid-template-columns: 28px 1fr auto;\r\n    grid-template-rows: auto auto;\r\n    column-gap: 8px;\r\n    row-gap: 0;\r\n    padding: 7px 10px;\r\n    border: none;\r\n    border-bottom: 1px solid #1e293b;\r\n    background: transparent;\r\n    margin: 0;\r\n    border-radius: 0;\r\n    align-items: center;\r\n  }\r\n\r\n  .table-wrapper .practice-table tbody tr:first-child {\r\n    border-top: 1px solid #1e293b;\r\n  }\r\n\r\n  .table-wrapper .practice-table td {\r\n    padding: 0;\r\n    border: none;\r\n    font-size: 13px;\r\n    line-height: 1.4;\r\n    display: block;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  /* Position number — spans both rows, centred */\r\n  .table-wrapper .practice-table td.col-pos {\r\n    grid-column: 1;\r\n    grid-row: 1 / 3;\r\n    text-align: center;\r\n    font-weight: 700;\r\n    font-size: 13px;\r\n    color: #94a3b8;\r\n    align-self: center;\r\n  }\r\n\r\n  /* Driver name — row 1, col 2 */\r\n  .table-wrapper .practice-table td:nth-child(2) {\r\n    grid-column: 2;\r\n    grid-row: 1;\r\n    font-weight: 600;\r\n    font-size: 13px;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n  }\r\n\r\n  /* Driver cell: allow name to truncate, keep badge visible */\r\n  .table-wrapper .practice-table td:nth-child(2) .practice-driver-cell {\r\n    display: flex;\r\n    max-width: 100%;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .table-wrapper .practice-table td:nth-child(2) .practice-driver-name {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    flex: 1 1 0;\r\n    min-width: 0;\r\n  }\r\n\r\n  .table-wrapper .practice-table td:nth-child(2) .practice-inline-number {\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  /* Car number — hidden */\r\n  .table-wrapper .practice-table td:nth-child(3) {\r\n    display: none;\r\n  }\r\n\r\n  /* Car model — row 2, col 2 */\r\n  .table-wrapper .practice-table td:nth-child(4) {\r\n    grid-column: 2;\r\n    grid-row: 2;\r\n    min-width: 0;\r\n  }\r\n\r\n  .table-wrapper .practice-table td:nth-child(4) .car-model-cell {\r\n    font-size: 11px;\r\n    color: #64748b;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block;\r\n  }\r\n\r\n  /* Best lap — row 1, col 3, right-aligned */\r\n  .table-wrapper .practice-table td:nth-child(5) {\r\n    grid-column: 3;\r\n    grid-row: 1;\r\n    text-align: right;\r\n    font-family: 'Courier New', monospace;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n  }\r\n\r\n  /* Total laps — row 2, col 3, right-aligned, muted */\r\n  .table-wrapper .practice-table td:nth-child(6) {\r\n    grid-column: 3;\r\n    grid-row: 2;\r\n    text-align: right;\r\n    font-size: 11px;\r\n    color: #64748b;\r\n  }\r\n\r\n  /* Date — hidden */\r\n  .table-wrapper .practice-table td:nth-child(7) {\r\n    display: none;\r\n  }\r\n\r\n  .table-wrapper .practice-table tbody tr.best-lap {\r\n    background-color: rgba(168, 85, 247, 0.07);\r\n  }\r\n\r\n  .practice-driver-modal {\r\n    max-height: 90vh;\r\n  }\r\n}\r\n\r\nbody.light-theme .table-wrapper .practice-table tr {\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .table-wrapper .practice-table tbody tr:first-child {\r\n  border-top-color: var(--border);\r\n}\r\n\r\nbody.light-theme .table-wrapper .practice-table td:nth-child(4) .car-model-cell,\r\nbody.light-theme .table-wrapper .practice-table td:nth-child(6) {\r\n  color: var(--muted);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
